import { defineRelations } from '@rstore/vue';
import { OrgRole } from './org-role';
import { User } from './user';
import { UserOrgRole } from './user-org-role';

export const OrgRoleRelations = defineRelations(OrgRole, ({ collection }) => ({
	users: {
		to: collection(UserOrgRole, {
			on: {
				'MonospaceUserOrgRole.orgRoleId': 'MonospaceOrgRole.id',
			},
		}),
		many: true,
	},
}));

export const UserOrgRoleRelations = defineRelations(UserOrgRole, ({ collection }) => ({
	user: {
		to: collection(User, {
			on: {
				'MonospaceUser.id': 'MonospaceUserOrgRole.userId',
			},
		}),
	},
	role: {
		to: collection(OrgRole, {
			on: {
				'MonospaceOrgRole.id': 'MonospaceUserOrgRole.orgRoleId',
			},
		}),
	},
}));
